// extracted by mini-css-extract-plugin
export default {"main":"StudyTests_main__JvNcA","link":"StudyTests_link__rpr4k","filterButtonsBlock":"StudyTests_filterButtonsBlock__j64Bf","listHidden":"StudyTests_listHidden__1asdr"};